import './HomeButton.css';
import HomeIcon from '../../../../images/game-page/house.svg';
import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { useActiveStateWithTimeoutHook } from '../../../../../shared/src/hooks/use-active-state-with-timeout.hook';
import { ExitGamePageConfirm } from '../ExitGamePageConfirm';
import { GamePageSettingsContext } from '../contexts/game-page-settings.context';
import { GamePageHeaderIconButton } from '../GamePageHeader/GamePageHeaderIconButton';

export const HomeButton = ({
    // full | icon
    mode = 'full',
}) => {
    const { t } = useTranslations();
    const {
        isActive: popupActive,
        deactivate: closePopup,
        activate: activatePopup,
    } = useActiveStateWithTimeoutHook({
        timeoutMs: 7_000,
    });
    const renderText = mode === 'full';

    const { exitGame } = useContext(GamePageSettingsContext);

    const iconClass = classNames(
        'game-page-header-home',
        `game-page-header-home--mode-${mode}`,
    );

    return <>
        <GamePageHeaderIconButton
            iconImage={HomeIcon}
            className={iconClass}
            onClick={activatePopup}
        >
            {renderText && <div className="game-page-header-home__text">{t('home')}</div>}
        </GamePageHeaderIconButton>

        {/* confirm popup */}
        {popupActive && <ExitGamePageConfirm
            closePopupHandler={closePopup}
            ctaActionHandler={exitGame.exitGameHandler}
            ctaText={exitGame.exitGameCtaText}
        />}
    </>;
};
